export class ConsentInfo {
    public title: string;
    public message: string;
    public url: string;

    constructor(title = '', message = '', url = '/') {
        this.title = title;
        this.message = message;
        this.url = url;
    }

    public static createFor(consentName: string): ConsentInfo {
        if (consentName === 'Google Maps') {
            return new ConsentInfo('GOOGLE_MAPS_CONSENT_TITLE', 'GOOGLE_MAPS_CONSENT_MESSAGE', '/company-search');
        }

        return new ConsentInfo('NOT_FOUND', 'NOT_FOUND');
    }
}
